import React from 'react';
import 'src/assets/scss/notification-banner.scss';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';

const getIcon = (severity) => {
  switch (severity) {
    case 'warning':
      return <ReportProblemRoundedIcon aria-hidden="true" fontSize="small" />;
    default: 
      return null;
  }
};

const NotificationBanner = ({
  severity = 'info',
  title,
  message,
  actionLabel,
  onAction,
  onClose,
  icon,
  ariaLive = 'polite',
  testId,
  customClassName,
  height = 50
}) => {
  if (!message) return null;

  return (
    <div
      role="status"
      aria-live={ariaLive}
      data-testid={testId}
      className={`system-notification-banner ${severity} ${customClassName}`}
      style={{ height: `${height}px` }}
    >
      <div className="content-left">
        <div className="icon-container">
          {getIcon(severity)}
        </div>
        {title ? <span className="f-w-600 mr-4">{title}</span> : null}
        <span>{message}</span>
        {actionLabel && onAction ? (
          <button type="button" className="action-button" onClick={onAction} aria-label={actionLabel}>
            {actionLabel}
          </button>
        ) : null}
      </div>
      <div className="content-right">
        {onClose ? (
          <button type="button" className="close-button" onClick={onClose} aria-label="Close notification">
            ×
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default NotificationBanner;
